import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BetHistoryList from './BetHistoryList';
import Pager from '../../../../../common/pager';
import getErrorText from './getErrorText';
import { betPropTypes } from '../BetPropTypes';
import {
    BET_HISTORY_MAX_PAGES_COUNT,
    BET_HISTORY_REDIRECT_CONFIG,
} from '../../../betHistory.constants';

export class BetHistoryIntegrated extends Component {

    componentWillMount() {
        this.requestInitialBetHistory(this.props.isSettled);
    }

    componentWillUnmount() {
        this.props.clearBetHistory();
    }

    handleToggleIsSettled = () => {
        this.props.toggleIsSettled();
        this.requestInitialBetHistory(!this.props.isSettled);
    }

    requestInitialBetHistory = (isSettled) => {
        const { getBetHistory, apiName } = this.props;
        getBetHistory(apiName, isSettled);
    }

    incrementPage = () => {
        const {
            currentPage,
            betHistoryPageChange,
        } = this.props;
        const page = currentPage + 1;
        betHistoryPageChange(page);
    }

    decrementPage = () => {
        this.props.betHistoryPageChange(this.props.currentPage - 1);
    }

    renderPageBody = () => {
        const {
            apiName,
            betHistory,
            isSettled,
            isLoading,
            currencySign,
            currentPage,
        } = this.props;
        const redirectConfig = BET_HISTORY_REDIRECT_CONFIG[apiName] || {};

        return currentPage === BET_HISTORY_MAX_PAGES_COUNT + 1 ?
            <div className="bs-betHistory__message">
                <span>
                    {redirectConfig.text} <a
                        href={`https://${redirectConfig.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {redirectConfig.link}
                    </a>.
                </span>
            </div> :
            <BetHistoryList
                isSettled={isSettled}
                isLoading={isLoading}
                currencySign={currencySign}
                bets={betHistory}
            />
    }

    render() {
        const {
            betHistory,
            isSettled,
            isLoading,
            currentPage,
            pageLength,
            betHistoryErrors,
            hasNextPage,
        } = this.props;
        const betHistoryErrorText = betHistoryErrors && getErrorText(betHistoryErrors);
        const isInitialBetHistoryLoading = isLoading && !betHistory.length;
        return (<div className="bs-betHistory">
            <div className="bs-account__tabHeader">
                <span className="bs-betHistory__title">
                    {isSettled ? 'Settled Bets' : 'Open Bets' }
                </span>
                <button
                    onClick={this.handleToggleIsSettled}
                    className="bs-btn bs-btn_major bs-betHistory__toggleButton"
                >
                    <span>{isSettled ? 'Show Open Bets' : 'Show Settled Bets'}</span>
                </button>
            </div>
            {
                betHistoryErrors ? (
                    <div className="bs-betHistory__error">
                        {betHistoryErrorText}
                    </div>
                ) : (
                    <div className={
                        classNames(
                            'bs-betHistory__content',
                            { 'bs-betHistory__content_spinner': isInitialBetHistoryLoading },
                        )}
                    >
                        {this.renderPageBody()}
                        <div className="bs-betHistory__footer">
                            <Pager
                                isLoading={isLoading}
                                currentPage={currentPage}
                                pageLength={pageLength}
                                currentPageLength={betHistory.length}
                                hasNextPage={hasNextPage}
                                onIncrementPage={this.incrementPage}
                                onDecrementPage={this.decrementPage}
                            />
                        </div>
                    </div>
                )
            }
        </div>);
    }
}

BetHistoryIntegrated.defaultProps = {
    isSettled: false,
    isLoading: false,
    betHistoryNext: null,
    betHistoryErrors: null,
    hasNextPage: false,
};

BetHistoryIntegrated.propTypes = {
    isSettled: PropTypes.bool,
    isLoading: PropTypes.bool,
    getBetHistory: PropTypes.func.isRequired,
    clearBetHistory: PropTypes.func.isRequired,
    betHistoryPageChange: PropTypes.func.isRequired,
    toggleIsSettled: PropTypes.func.isRequired,
    apiName: PropTypes.string.isRequired,
    betHistory: PropTypes.arrayOf(betPropTypes).isRequired,
    currencySign: PropTypes.string.isRequired,
    pageLength: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    betHistoryErrors: PropTypes.objectOf(PropTypes.shape({
        message: PropTypes.string,
    })),
    hasNextPage: PropTypes.bool,
};

export default BetHistoryIntegrated



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/betHistory/components/BetHistoryIntegrated.jsx